import React, {Fragment} from 'react';
import PropTypes from "prop-types";

export default function CsfMembreDossierUfcTable({ ufcList, periodTitle, periodSubTitle, periodInOrder, collapse = false, printId, setCheckedPrintOption, conformityEndDate }) {

  const accordionId = `summary__accordeon-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
  const completeConformityUrl = window.Drupal.t('membre.link.obligatory.course');
  const langcode = document.documentElement.lang;

  return (
    <>
      <h2>
        {periodTitle}
        <span>{periodSubTitle}</span>
      </h2>
      <div className="summary__legend mt-6 mb-1 d-flex flex-wrap flex-md-nowrap justify-content-between align-items-end">
        <div className="summary__tag-wrapper d-flex flex-column flex-md-row mr-md-2 mb-1 mb-md-0 w-100 w-md-auto">

          {periodInOrder ? (
            <span className="espaces__tag">{window.Drupal.t('membre.completeUFC.tag')}</span>
          ) : (
            <span className="espaces__tag espaces__tag--error">{window.Drupal.t('membre.incompleteUFC.tag')}</span>
          )}

        </div>
        <div className="accordion ml-auto" id={accordionId}>
          <div className="accordion-item">
            <h2 className="m-0">
              <button
                className="espaces__table-accordion d-flex align-items-center"
                type="button" data-toggle="collapse"
                data-target={`#${accordionId}__current-btn`} aria-expanded={!collapse}
                aria-controls={`${accordionId}__current-btn`}
                aria-label={`${periodTitle} - ${window.Drupal.t('membre.summary.detail.aria-label')}`}>
                <span>{window.Drupal.t('Details')}</span><img className="img-arrow"
                  src="/themes/custom/tink/dist/assets/chevron-left.svg"
                  alt="chevron" />
              </button>
            </h2>
          </div>
        </div>
      </div>
      <div id={`${accordionId}__current-btn`} className={`accordion-collapse collapse ${collapse ? '' : 'show'}`}>
        <div className="accordion-body">
          <div className="inner-wrapper">
            <div className="table-wrapper-ufc">
              <table className="summary__table w-100">
                <thead>
                  <tr>
                    <th>
                      {window.Drupal.t('membre.summary.category')}
                    </th>
                    <th>
                      {window.Drupal.t('membre.summary.asked-ufc')}
                    </th>
                    <th>
                      {window.Drupal.t('membre.summary.completed-ufc')}
                    </th>
                    <th>
                      {window.Drupal.t('membre.summary.missing-ufc')}
                    </th>
                    <th width="148">
                      {window.Drupal.t('membre.summary.completed')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {ufcList?.length === 0 && (
                    <tr>
                      <td colSpan="5">
                        <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
                      </td>
                    </tr>
                  )}
                  {ufcList.map((item, index) => (
                    <Fragment key={item.REDU_Edu_File__Subject_Id}>
                      <tr className={index % 2 === 0 ? 'even' : 'odd'}>
                        <td>
                          {langcode === 'fr' ?  item.Subject_Name_French : item.Subject_Name_English}
                        </td>
                        <td>
                          {item.UFC_Required}
                        </td>
                        <td>
                          {item.UFC_Aquired_Total}
                        </td>
                        <td>
                          {item.UFC_Missing_Total}
                        </td>
                        <td>
                          {item.In_Order === 'Oui' || item.In_Order === 'Yes' ? (
                            <span
                              className="espaces__tag espaces__tag--slim">{window.Drupal.t('Yes')}</span>
                          ) : item.In_Order === 'Non' || item.In_Order === 'No' ? (
                            <span
                              className="espaces__tag espaces__tag--error espaces__tag--slim">{window.Drupal.t('No')}</span>
                          ) : (
                            <span title={window.Drupal.t('membre.tag.na.tooltip')}
                              className="espaces__tag espaces__tag--gray espaces__tag--slim">{window.Drupal.t('membre.tag.na')}</span>
                          )}
                        </td>
                      </tr>
                      {/* Row "conformité" */}
                      {item.REDU_Subject_Id === 'AAAAAAAAACI=' && (
                        <tr className="odd extra-row">
                          <td colSpan="5">
                            <span className="visually-hidden">
                              {langcode === 'fr' ?  item.Subject_Name_French : item.Subject_Name_English}: {window.Drupal.t('membre.course.to.complete')}. {conformityEndDate && (<> {window.Drupal.t('membre.course.to.complete.desc')} {conformityEndDate}</>)}
                            </span>
                            <div className="d-flex justify-content-between flex-wrap align-items-center">
                              <p aria-hidden="true" className="text-left">
                                {window.Drupal.t('membre.course.to.complete')}<br />
                                {conformityEndDate && (
                                  <span className="espaces__extra-details">{window.Drupal.t('membre.course.to.complete.desc')} {conformityEndDate}</span>
                                )}

                              </p>
                              <div>
                                {item.UFC_Acquired_Mandatory === 1 ? (
                                  <img src="/themes/custom/tink/dist/assets/icon-member-check.svg" alt="" aria-label={window.Drupal.t('broker.compliance.ufcAcquiredMandatory.fromapi')} />
                                ) : (
                                  <>
                                  <img src="/themes/custom/tink/dist/assets/icon-member-clock.svg" alt="" />
                                  <a className="table-wrapper-ufc__link" href={completeConformityUrl}>
                                    <i className="icon icon-member-arrow"><span className="d-none">&nbsp;</span></i>
                                    <span className="visually-hidden">{window.Drupal.t('membre.dossier.complete-link.text')}</span>
                                  </a>
                                  </>
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </Fragment>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end">
              <button className='button btn-outlined btn-with-icon mb-2' onClick={() => setCheckedPrintOption(printId)} type="button" data-toggle="modal" data-target="#membrePrintModal">
                <i className="icon icon-print supplier-icon"><span className="d-none">&nbsp;</span></i>
                {window.Drupal.t('membre.btn.print.label')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

CsfMembreDossierUfcTable.propTypes = {
  ufcList: PropTypes.array.isRequired,
  periodTitle: PropTypes.string,
  periodSubTitle: PropTypes.string,
  periodInOrder: PropTypes.bool,
  collapse: PropTypes.bool,
  printId: PropTypes.string,
  setCheckedPrintOption: PropTypes.func,
  conformityEndDate: PropTypes.string
};
